import { useState, useEffect } from "react";
import { useRedux } from "src/shared/hooks";
import MetricModel from "src/shared/models/MetricModel";
import appFetch from "src/shared/fetch";
import { IRootState } from "src/shared/types";
import NS from "src/shared/utils/NS";
import { getXClientIdHeader } from "src/utils/getservicename";

function mapStateToProps(state: IRootState) {
  return { timerange: state.app.selectedTab };
}

export function useMetricsMetadata(): readonly [any[], NS] {
  const { timerange } = useRedux(mapStateToProps, {});
  const [metrics, setMetrics] = useState<any[]>([]);
  const [status, setStatus] = useState(new NS("INIT"));

  useEffect(() => {
    setStatus(new NS("LOADING"));
    appFetch
      .get(`/api/anobis/metrics/access`, { params: { timeTab: timerange }, headers: getXClientIdHeader() })
      .then(({ response, error }) => {
        if (response) {
          setStatus(new NS("SUCCESS"));
          setMetrics(response.map((metadata) => new MetricModel(metadata)));
        } else if (error) {
          setStatus(new NS("ERROR"));
          setMetrics([]);
        }
      })
      .catch((err) => {
        console.error(err);
        setStatus(new NS("ERROR"));
        setMetrics([]);
      });
  }, []);

  return [metrics, status] as const;
}
